import { useState } from "react";
import DialogBox from '../LayoutComponents/Dialogbox.jsx';

export default function Setup({ gyroSettings, setGyroSettings }) {
	const [message] = useState("Klicke auf die Punkte entlang der Strasse und erlebe die neuen Qualitäten dieses urbanen Grünraumes");
	const desktopText =  (
		<>
			Klicke auf die Punkte entlang der Strasse 
			<br />
			und erlebe die neuen Qualitäten dieses urbanen Grünraumes.
		</>)
	const mobileText =  (
		<>
			Tippe auf die Punkte entlang der Strasse 
			<br />
			und erlebe die neuen Qualitäten 
			<br />
			dieses urbanen Grünraumes.
			<br />
			<br />
			5G<sup><img src="/images/ui/T_UI_5G.png" alt="5G" className="inline-icon" /></sup> empfohlen.
		</>)
    const isDesktop = /Windows NT|Macintosh|Linux/i.test(navigator.userAgent) && !/Android/i.test(navigator.userAgent);
    
    // 2. Only consider mobile for Gyro if it's NOT a desktop-class device
    const isMobile = !isDesktop && (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || navigator.maxTouchPoints > 0);	
	const displayMessage = isMobile ? mobileText : desktopText;

	async function handleHotspotInteraction(sceneMedia) {
		let useGyro = false;
		if (isMobile) {
			// 2. Check for strict permission requirements (iOS 13+)
			if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
				try {
					const permissionState = await DeviceOrientationEvent.requestPermission();
					if (permissionState === 'granted') {
						useGyro = true;
					}
				} catch (error) {
					console.error("Device orientation permission request denied or failed:", error);
				}
			} else {
				// 3. Android and older iOS devices allow gyro access by default
				useGyro = true;
			}
		}

		// 4. Update the state to initialize the Scene
		setGyroSettings({
			useGyro: useGyro,
			permissionProcessed: true,
			initialSceneMedia: sceneMedia 
		});
	}

	return (
		<DialogBox
			text={displayMessage} // Pass the conditional text here
			onHotspotClick={handleHotspotInteraction}
		/>
	);
}